import { IEltCustomerRevenue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCustomerRevenue'
import { CUSTOMER_REVENUE_TOTAL } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import { getPercentDiff } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPercentDiff'
import { getPostfixByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPostfixByActualsValueType'
import { IChangeComputedFieldsProps } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IChangeComputedFieldsProps'
import { getFixedSumAll } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/helpers/getFixedSumAll'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

const getNumberValue = (item: IEltCustomerRevenue, field: string): number => {
  return Number(item[field as keyof IEltCustomerRevenue]) || 0
}

const getFieldWithPostfix = (field: string, postfix: string): keyof IEltCustomerRevenue => {
  return `${field}${postfix}` as keyof IEltCustomerRevenue
}

const getYoYFields = (
  actualValueTypes: ActualsValueTypes[],
  item: IEltCustomerRevenue
): Partial<IEltCustomerRevenue> => {
  return actualValueTypes.reduce<Partial<IEltCustomerRevenue>>((acc, valueType) => {
    const postfix = getPostfixByActualsValueType(valueType)

    const curYearField = getFieldWithPostfix('CurYearTotal', postfix)
    const prevYearField = getFieldWithPostfix('PrevYearTotal', postfix)
    const yoyField = getFieldWithPostfix('YoY', postfix)

    return {
      ...acc,
      [yoyField]: getPercentDiff(
        getNumberValue(item, curYearField),
        getNumberValue(item, prevYearField)
      ),
    }
  }, {})
}

export const calculateCustomerRevenueTotalAndYoY = ({
  field,
  data,
  actualValueTypes,
}: IChangeComputedFieldsProps<IEltCustomerRevenue>) => {
  const grandTotalIndex = data.findIndex((el) => el.TranslationKey === CUSTOMER_REVENUE_TOTAL)
  const totalItem = data[grandTotalIndex]

  const itemsToSum = data.filter((item) => item.TranslationKey !== CUSTOMER_REVENUE_TOTAL)

  const summedValue = getFixedSumAll(...itemsToSum.map((item) => getNumberValue(item, field)))

  if (grandTotalIndex !== -1) {
    data[grandTotalIndex] = {
      ...totalItem,
      [field]: summedValue,
    }
  }

  return data.map((item) => ({
    ...item,
    ...getYoYFields(actualValueTypes, item),
  })) as IEltCustomerRevenue[]
}
